import React, { Component } from 'react'
import _ from 'lodash';

function convertMoney(amount) {
    if (!_.isNumber(+amount)) return '';
    return ((+amount)/100).toFixed(2)
}
export function DejaPrice ({product}) {
    return (
        <span>
        <span style={{
            color: product.current_price < product.original_price ? '#F81F34' : 'rgba(38,39,41,0.90)'
        }}>{`S$ ${convertMoney(product.current_price)}`}</span>
        {product.current_price < product.original_price && <span className="orginal-price">{`S$ ${convertMoney(product.original_price)}`}</span>}
        </span>
    )
}


// WEBPACK FOOTER //
// ./src/features/commonUI/price.js